import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatItalianNumber } from 'utils/formatUtils';
import { FamExpansionState } from './hooks/useFamFofExpansion';
import styles from './famFofConstituents.module.scss';

/**
 * «Composizione del fondo» inset under an expanded FAM FoF row in the
 * portfolio composition tables (issue #90): top 10 constituents by weight,
 * the rest grouped into one «Altro» row.
 */
export const FamFofConstituents: React.FC<{ state: FamExpansionState }> = ({ state }) => {
  const { t } = useTranslation();

  if (state === 'loading') {
    return <div className={styles.panel}>{t('productCard.caricamento')}</div>;
  }
  if (state === 'error') {
    return <div className={styles.panel}>{t('productCard.informazioniNonDisponibili')}</div>;
  }

  return (
    <div className={styles.panel}>
      <div className={styles.header}>
        <span className={styles.title}>{t('productCard.composizioneFondo')}</span>
        <span className={styles.date}>
          {t('productCard.gestoreData')} {state.data}
        </span>
      </div>
      <table className={styles.table}>
        <thead>
          <tr>
            <th className={styles.th}>{t('productCard.strumento')}</th>
            <th className={styles.th}>{t('productCard.isin')}</th>
            <th className={styles.th}>{t('productCard.categoria')}</th>
            <th className={`${styles.th} ${styles.right}`}>{t('productCard.peso')}</th>
          </tr>
        </thead>
        <tbody>
          {state.constituents.map((h) => (
            <tr key={`${h.isin}-${h.strumento}`}>
              <td className={styles.td}>{h.strumento}</td>
              <td className={styles.td}>{h.isin}</td>
              <td className={styles.td}>{h.categoria}</td>
              <td className={`${styles.td} ${styles.right}`}>{formatItalianNumber(h.peso, 2)}%</td>
            </tr>
          ))}
          {state.altro_peso !== null && (
            <tr>
              <td className={`${styles.td} ${styles.altro}`}>{t('productCard.altro')}</td>
              <td className={styles.td} />
              <td className={styles.td} />
              <td className={`${styles.td} ${styles.right} ${styles.altro}`}>
                {formatItalianNumber(state.altro_peso, 2)}%
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};
